import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner"; 
import { Router } from '@angular/router';

@Injectable()
export class UserService {
  public API_URL = BASE_URL.URL;

  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private route: Router) {
  }

  isAuthenticated() {
    const token = localStorage.getItem('token');
    if (token) {
      return true;
    } else {
      return false;
    }
  }

  setToken(token: string, roleData: any): void {
    localStorage.setItem('token', token);
    localStorage.setItem('role', JSON.stringify({
      id: roleData.id,
      name: roleData.name,
      resource_id: roleData.resource_id,
    }));
    
    if (roleData.permissions) {
      localStorage.setItem('permissions', JSON.stringify(roleData.permissions));
    }
  }

  setAuthToken(token: any): void {
    localStorage.setItem('token', token);
  }

  setRoleId(id: any): void {
    localStorage.setItem('roleId', id);
  }

  setRoleDetails(roles: any): void {
    localStorage.setItem('roles', JSON.stringify(roles));
  }

  getToken(): any {
    if (localStorage.getItem('token')) {
      return localStorage.getItem('token');
    }
  }

  getUsers(page: string = "", search: string = "", roles: Array<string> = [], createdAt: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/users?page=${page}&search=${search}&roles=${roles}&created_at=${createdAt}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  addUsers(data): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.post(`${this.API_URL}/users`, data,{
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  editUser(userId: string|number, data): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.put(`${this.API_URL}/users/${userId}`, data,{
        headers: {
          'Authorization': 'Bearer ' + token   
        }
      })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  editProfileUser(userId: string|number, data): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.put(`${this.API_URL}/users/profile/${userId}`, data,{
        headers: {
          'Authorization': 'Bearer ' + token   
        }
      })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  editPassword(userId: string|number, data): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.post(`${this.API_URL}/users/update_password/${userId}`, data,{
        headers: {
          'Authorization': 'Bearer ' + token   
        }
      })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }


  getUserDetails(userId: string|number, addedBy: number = 0): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/users/${userId}?added_by=${addedBy}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getRoles(fields: Array<string> = [], search: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/roles?fields=${fields}&search=${search}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getRoleDetails(roleId: number, permissions: number = 1): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.API_URL}/roles/${roleId}?permissions=${permissions}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  addRoles(data): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.post(`${this.API_URL}/roles`, data,{
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  updateRoles(roleId: string|number, data): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.put(`${this.API_URL}/roles/${roleId}`, data,{
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  updatePassword(userId: string|number, body: { password: string }): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.post(`${this.API_URL}/users/update_password/${userId}`, body,{
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  deleteUser(userId: string|number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.delete(`${this.API_URL}/users/${userId}`,{
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else if(error.status === 422){
      this.spinnerService.hide();
      return throwError(()=> error);
    }else{
      this.spinnerService.hide();
      console.error('server error:', error);
      return throwError(()=> error);
    }

  }

}
